/* eslint-disable */
import { useParams } from "react-router";
import { openHistoryReport } from "../utils/history";

export function useReportId() {
  const params = useParams();
  const reportId = params["reportId"];
  return reportId;
}